/** Weive Forms embed for the marketing Contact page. */
export const contactFormOrigin = 'https://forms.cqlghana.com';

export const contactFormKey = 'wf_OCN2hjsEone2spNGl7mKlgh72CHBRLRs';
